<template>
  <section class="catalogue">
		<div class="max-width side-padding">
      <h2 class="title-medium section-title centered">Catalogo</h2>
      <p class="intro normal arial centered">Le Edizioni Musicali Caramba, fondate nel 1965<br>si occupano da oltre 50 anni di regalarvi i più grandi<br>successi delle migliori orchestre italiane</p>

      <div class="col-4">
        <article 
          class="album-preview aos-init aos-animate" 
          data-aos="fade-up" 
          :data-aos-delay="200 * index" 
          v-for="(item, index) in catalogueItems"
          :key="item.id"> 
          
          <router-link :to="'/catalog/' + item.album.slug">
            <div class="album-img-block">
              <img v-if="item.album.cover.path" :src="item.album.cover.path" />
              <img v-else src="/themes/caramba/assets/images/album.jpg" />
            </div>
            <h1 class="title-small regular">{{ item.album.artist.name }}</h1>
            <h2 class="title-small light">{{ item.album.title }}</h2>
          </router-link>
          
          <p class="normal arial">{{ item.album.category.name }}</p>
        </article>
      </div>

      <div class="centered catalogue-cta">
        <router-link to="/catalog" class="button button-big button-purple button-anim">Scopri il catalogo</router-link>
      </div>
      </div>
	</section>
</template>

<script>
import axios from 'axios/dist/axios';

export default {
  data() {
    return {
      catalogueItems: []
    }
  },
  mounted() {
    axios.get(window.location.origin + '/api/v1/showcase/list')
      .then(resp => {
        this.catalogueItems = resp.data;
      });
  }
}
</script>


// WEBPACK FOOTER //
// src/vue/components/HomeCatalogue.vue